enum Colors {
  Primary = "primary",
  Secondary = "secondary",
  Success = "success",
  Error = "error",
  Info = "info",
  Warning = "warning",
  Caution = "caution",
  Hold = "hold",
  Teal = "teal",
  Blue = "blue",
  Green = "green",
  Red = "red",
  White = "white",
  Black = "black",
  Cyan = "cyan",
  Grey = "grey",
  Purple = "purple",
  DeepPurple = "deepPurple",
  Indigo = "indigo",
  Orange = "orange",
  BlueGrey = "bluegrey",
  Amber = "amber",
  Pink = "pink",
  LightBlue = "lightblue",
  Yellow = "yellow",
  Overlay = "overlay",
}

export { Colors };
